module.exports = __webpack_public_path__ + "img/hero-battery.d2f8001.svg";